import { AdsFooterLink } from '../ads-footer-link/ads-footer-link';
import { AdsFooterLinkHeader } from '../ads-footer-link-header/ads-footer-link-header';
import { FooterSection } from '../../ads-footer.types';
import { FunctionalComponent, VNode, h } from '@stencil/core';

export const AdsFooterLinkSection: FunctionalComponent<FooterSection> = ({ sectionHeader, sectionLinks }) => {
  return sectionHeader || sectionLinks?.length > 0
    ? ((
        <div class="footer-link-section">
          <AdsFooterLinkHeader
            link={sectionHeader.link}
            text={sectionHeader.text}
            title={sectionHeader.title}
            headingLevel={sectionHeader.headingLevel}
          />
          <ul class="c-footer__link-list">
            {sectionLinks?.map((slink) => (<AdsFooterLink link={slink.link} text={slink.text} title={slink.title} />) as VNode)}
          </ul>
        </div>
      ) as VNode)
    : null;
};
